// extracted by mini-css-extract-plugin
module.exports = {"token":"HotTokenAdmin_token__3uHRW","name":"HotTokenAdmin_name__3Cwna","image":"HotTokenAdmin_image__T851j"};